__webpack_require__.p = "https://back.siriuspt.eu/";